var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicpenYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magicpen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9814 11.3196C17.4597 11.4439 16.852 11.6536 16.2562 12.0066C15.1752 12.6469 14.1701 13.7383 13.7649 15.5425C13.3608 13.7294 12.3548 12.6362 11.2715 11.9971C10.6716 11.6432 10.0598 11.4351 9.53604 11.3129C10.0515 11.1898 10.6502 10.9832 11.238 10.6372C12.3234 9.99841 13.3342 8.90511 13.7402 7.09092C14.1463 8.90523 15.1578 9.99867 16.2458 10.6375C16.8456 10.9896 17.4571 11.1973 17.9814 11.3196Z",
    fill: "#DAAE15",
    stroke: "#DAAE15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.0028 4.9981C7.37719 5.36578 6.80259 5.99605 6.57539 7.0302C6.35382 5.98291 5.78026 5.34553 5.15169 4.97447C4.79702 4.76511 4.43536 4.64643 4.13017 4.5793C4.43229 4.5118 4.79026 4.39355 5.14202 4.18681C5.78188 3.81075 6.36839 3.15999 6.58441 2.08336C6.80044 3.15999 7.38695 3.81075 8.02681 4.18681C8.39792 4.40492 8.77593 4.52454 9.08799 4.58998C8.77142 4.65427 8.38347 4.77437 8.0028 4.9981Z",
    fill: "#DAAE15",
    stroke: "#DAAE15",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.39387 15.8046C2.03921 15.5952 1.67755 15.4765 1.37235 15.4094C1.67448 15.3419 2.03244 15.2236 2.3842 15.0169C3.02407 14.6408 3.61058 13.9901 3.8266 12.9134C4.04262 13.9901 4.62913 14.6408 5.269 15.0169C5.6401 15.235 6.01812 15.3546 6.33018 15.4201C6.01361 15.4843 5.62566 15.6044 5.24498 15.8282C4.61938 16.1959 4.04478 16.8261 3.81758 17.8603C3.59601 16.813 3.02245 16.1756 2.39387 15.8046Z",
    fill: "#DAAE15",
    stroke: "#DAAE15",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpenYellow);
export default __webpack_public_path__ + "static/media/magicpenYellow.a14f21fdeac14a8f026773016add5cef.svg";
export { ForwardRef as ReactComponent };